import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { LicenseInfo } from '@mui/x-license'
import './index.css'
import App from './App.jsx'

const muiXProLicenseKey =
  import.meta.env.VITE_MUIX_LICENSE_KEY || import.meta.env.VITE_MUI_X_LICENSE_KEY || ''

if (muiXProLicenseKey) {
  LicenseInfo.setLicenseKey(muiXProLicenseKey)
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
